import React, { useContext, useEffect, useState } from 'react';
import Button from '../WebfitButton/WebfitButton';
import TileHeader from '../WebfitTileHeader/WebfitTileHeader';
import Styles from './PingNationWebfitTile.module.scss';
import FittingRecommendationsList from '../FittingRecommendationsList/FittingRecommendationsList';
import { LocalizationContext } from '../../context/localizationContext';
import { fittingRecommendationsContext } from '../../context/fittingRecommendationsContext';
import APIClient from '../../helpers/APIClient';
import LoadingSpinner from '../WebfitLoadingSpinner/WebfitLoadingSpinner';
import WebfitLogo from '../../assets/logos/WebfitLogoLight.svg';
import ArrowRight from '../../assets/images/icons/arrow-left.svg';
import ExternalLink from '../../assets/images/icons/external-link.svg';
import MyFittingProfile from '../MyFittingProfile/MyFittingProfile';

const PingNationWebfitTile = (props) => {
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const {
    tileMessages, webFitResults, fittingProfile, buttons,
  } = localizationState.localization;
  const fittingRecommendationContext = useContext(
    fittingRecommendationsContext,
  );
  const { state, dispatch } = fittingRecommendationContext;
  const { fittingRecommendations } = state;
  const [serviceDown, setServiceDown] = useState(false);
  const [loading, setLoading] = useState(false);
  const fittingResults = 'FITTING_RESULTS';
  const myFittingProfile = 'MY_FITTING_PROFILE';
  const [activeView, setActiveView] = useState(fittingResults);

  const getProfile = () => {
    setLoading(true);
    APIClient.getFeaturedProfileById((status, res) => {
      if (status === 200) {
        dispatch({
          type: 'SET_RECOMMENDATIONS_AND_PROFILE',
          fittingRecommendations: res.data.BagRecommendation,
          userProfile: res.data.UserProfile,
          fullBagJson: res.data.FullBagJson,
          lastUpdatedDate: res.data.UpdatedAt,
        });
      }

      if (status === 500 || status === 401) {
        setServiceDown(true);
      }
      setLoading(false);
    });
  };

  const navigateToWebfit = (url) => {
    window.open(url, '_blank', 'noreferrer');
  };

  useEffect(() => {
    getProfile();
  }, []);

  const getTileContent = () => {
    if (fittingRecommendations) {
      return (
        <>
          <TileHeader serviceDown={serviceDown} onClick={navigateToWebfit} />
          <div className={Styles.viewToggleButtons}>
            <button
              type="button"
              className={`${Styles.viewToggleButton} ${
                activeView === fittingResults ? Styles.active : ''
              }`}
              onClick={() => setActiveView(fittingResults)}
            >
              {webFitResults.navButtonText}
            </button>
            <button
              type="button"
              className={`${Styles.viewToggleButton} ${
                activeView === myFittingProfile ? Styles.active : ''
              }`}
              onClick={() => setActiveView(myFittingProfile)}
            >
              {fittingProfile.navButtonText}
            </button>
          </div>
          {activeView === fittingResults && (
            <div className={Styles.recommendationsListTileContainer}>
              <FittingRecommendationsList />
              <div className={Styles.footer}>
                <button
                  className={Styles.viewFittingRecommendationsFooterBtn}
                  type="button"
                  onClick={() => navigateToWebfit(process.env.REACT_APP_WEBFIT_URL)
                  }
                >
                  {buttons.viewAllResults}
                  <img src={ArrowRight} alt="arrow-right" />
                </button>
              </div>
            </div>
          )}
          {activeView === myFittingProfile && <MyFittingProfile />}
        </>
      );
    }

    return (
      <div className={Styles.noFittingRecommendationsMessage}>
        <div
          className={Styles.header}
          dangerouslySetInnerHTML={{
            __html: !serviceDown
              ? tileMessages.noRecommendations.header
              : tileMessages.errors.errorHeading,
          }}
        />
        <img className={Styles.webfitLogo} src={WebfitLogo} alt="WebFit Logo" />
        {loading && (
          <div className={Styles.loadingContainer}>
            <LoadingSpinner />
          </div>
        )}
        {!loading && (
          <div>
            <div className={Styles.tileMessageLine1}>
              {!serviceDown
                ? tileMessages.noRecommendations.messageLine1
                : tileMessages.errors.messageLine1}
            </div>
            <div className={Styles.tileMessageLine2}>
              {!serviceDown
                ? tileMessages.noRecommendations.messageLine2
                : tileMessages.errors.messageLine2}
            </div>
          </div>
        )}
        {!loading && !serviceDown && (
          <Button
            label={buttons.getFit}
            iconAfter={ExternalLink}
            onClick={() => navigateToWebfit(process.env.REACT_APP_WEBFIT_URL)}
          />
        )}
      </div>
    );
  };

  return <div className={Styles.tile}>{getTileContent()}</div>;
};

export default PingNationWebfitTile;
